import React from 'react';
import styled, { css } from 'styled-components';
import { Box, ViewAnimation, themeUtils as tu } from '@zen-common/components-base';
import OrderBookTable from './components/OrderBookTable';
import MakeOrderForm from './components/Make/MakeOrderForm';

const GRID_PADDING = 'xs';

const OrderBook = () => {
  const isMobile = document.body.clientWidth < tu.breakpoints.xl.replace('px', '');
  return (
    <ViewAnimation>
      <StyledGrid>
        <MakeFormWrapper>
          <MakeOrderForm />
        </MakeFormWrapper>
        <TablesContainer>
          <TableCol>
            <OrderBookTable title="BUY ORDERS" isBuy isMobile={isMobile} />
          </TableCol>
          <TableCol>
            <OrderBookTable title="SELL ORDERS" isMobile={isMobile} />
          </TableCol>
        </TablesContainer>
      </StyledGrid>
    </ViewAnimation>
  );
};

export default OrderBook;

const StyledGrid = styled(Box)`
  height: 100%;
  flex-grow: 1;
  padding-top: ${tu.space(GRID_PADDING)};
  display: flex;
  justify-content: flex-start;
  max-width: 1920px;
  margin: 0 auto;
  ${tu.mq({
    flexDirection: ['column', null, null, 'row'],
  })}
`;
const MakeFormWrapper = styled(Box)`
  ${css(
    tu.mq({
      height: ['auto', null, null, '100%'],
      flexGrow: [1, null, null, 0],
      minWidth: [null, null, null, '320px'],
      marginRight: [0, null, null, tu.space(GRID_PADDING)],
      marginLeft: [0, null, null, tu.space(GRID_PADDING)],
      marginBottom: [tu.space(GRID_PADDING), null, null, 0],
    })
  )}
`;
const TablesContainer = styled(Box)`
  flex-grow: 1;
  height: 100%;
  display: flex;
  ${tu.mq({
    flexDirection: ['column', null, null, 'row'],
    overflowX: ['visible', null, null, 'auto'],
    marginRight: [0, null, null, tu.space(GRID_PADDING)],
  })}
`;

const TableCol = styled(Box)`
  flex-grow: 1;
  min-height: 300px;
  ${tu.mq({
    height: ['auto', null, null, '100%'],
    minWidth: [null, null, null, '470px'],
    width: ['100%', null, null, 'auto'],
    marginRight: [0, null, null, tu.space(GRID_PADDING)],
    marginBottom: [tu.space(GRID_PADDING), null, null, 0],
  })}

  &:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }
`;
